<dialogContent>
  <tt-drag-and-drop
    [attachedResources]="attachedResourcesConverted"
    [availableResources]="availableResourcesConverted"
    [deletedImportedResourceIds]="deletedImportedAttachmentIds"
    [dialogType]="guidelineDialogTypes.Attachment"
    [disableUploadButton]="uploading || !this.file"
    [isUploadInProgress]="isUploadInProgress"
    [loading]="loading"
    [testidDialogType]="'attachments'"
    [title]="'AssetManagement'"
    [uploading]="uploading"
    (fileNameChanged)="onFileNameChanged($event)"
    (onUploadBtnClicked)="onAdd()"
    (searchTermChanged)="onSearchTermChanged($event)"
    (updateResources)="onUpdateResources($event)"
    (uploadFile)="onUploadFile($event)"
    (uploadInProgressChanged)="onUploadInProgressChanged($event)" />
</dialogContent>
<dialogActions>
  <div class="actions-container">
    <button data-testid="attachment-dialog_cancel-button" ttButton variant="secondary" (click)="onCloseDialog()">
      <span>{{ 'Cancel' | transloco }}</span>
    </button>
    @if (!isUploadInProgress) {
      <button data-testid="attachment-dialog_save-button" ttButton (click)="onSaveDialog()">
        <span>{{ 'Save' | transloco }}</span>
      </button>
    }
  </div>
</dialogActions>
